import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Check, Storefront } from "@phosphor-icons/react";

export default function BecomeVendor() {
  const { user } = useAuth();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => { api.get("/vendor/plan").then(({ data }) => setPlan(data)); }, []);

  const subscribe = async () => {
    if (!user) { nav("/register?next=/become-vendor"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/vendor/subscribe", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not start subscription");
      setLoading(false);
    }
  };

  const isVendor = user && (user.role === "vendor" || user.role === "admin");

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-12 gap-12" data-testid="vendor-page">
      <div className="lg:col-span-7">
        <p className="overline text-signal mb-3">// Sell with us</p>
        <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter leading-[0.95] mb-6">
          Your products.<br /><span className="neon-text">Our storefront.</span>
        </h1>
        <p className="text-neutral-400 max-w-xl leading-relaxed mb-10">
          Become a vendor for one flat monthly fee. List your own products, get featured ad placement
          at the top of the shop, and reach buyers across Southern California and beyond.
        </p>
        <ul className="space-y-4">
          {(plan?.benefits || []).map((b) => (
            <li key={b} className="flex items-center gap-3">
              <span className="w-6 h-6 bg-signal flex items-center justify-center"><Check size={14} weight="bold" /></span>
              <span>{b}</span>
            </li>
          ))}
        </ul>
      </div>

      <aside className="lg:col-span-5 border border-signal bg-[#111111] p-8 shadow-[0_0_32px_rgba(255,7,58,0.35)] h-fit" data-testid="vendor-plan-card">
        <Storefront size={32} weight="duotone" className="text-signal mb-4" />
        <p className="overline opacity-60">Vendor membership</p>
        <p className="font-display font-black text-6xl tracking-tighter mt-2" data-testid="vendor-price">
          ${plan ? plan.price_usd.toFixed(0) : "—"}<span className="text-xl font-light opacity-60">/mo</span>
        </p>
        <p className="font-mono text-xs opacity-50 mb-8">Cancel anytime · billed monthly</p>

        {isVendor ? (
          <Link to="/admin" className="btn-signal w-full justify-center" data-testid="vendor-dashboard-link">
            Go to dashboard →
          </Link>
        ) : (
          <>
            <div className="mb-4 border border-white/10 p-3 font-mono text-xs opacity-70" data-testid="vendor-payment-note">
              Billed monthly by card. Crypto is available for product orders and deliveries.
            </div>
            <button onClick={subscribe} disabled={loading} className="btn-signal w-full justify-center" data-testid="vendor-subscribe-btn">
              {loading ? "Redirecting…" : user ? "Subscribe & start selling →" : "Create account to subscribe →"}
            </button>
          </>
        )}
      </aside>
    </main>
  );
}
